import { Injectable } from '@angular/core'
import { CustomHttpClient } from '@adex/shared/network/custom-http-client'
import { Observable } from 'rxjs'
import { IAddPaymentMethod, IFinanceExpensesState, IFinanceOverviewState } from '@adex/shared/models/states/finance.state'
import { urls } from '@adex/shared/network/urls'
import { NetworkResponse } from '@adex/shared/network/response'
import { IPagination } from '@adex/shared/models/pagination'
import { map } from 'rxjs/operators'


@Injectable()
export class FinanceNetworkService {

  constructor(private readonly http: CustomHttpClient) {
  }

  public getFinanceOverview(): Observable<NetworkResponse<IFinanceOverviewState>> {
    return this.http.get<NetworkResponse<IFinanceOverviewState>>(urls.finance.overview)
  }

  public getFinanceExpenses(pagination: IPagination): Observable<NetworkResponse<IFinanceExpensesState>> {
    return this.http.post<any, any>(urls.finance.expenses, { pagination: { ...pagination, hasMore: undefined } }).pipe(
      map((d) => ({ data: d.expenses, pagination: d.pagination } as any))
    )
  }

  public getSubscriptionTypes() {
    return this.http.get(urls.finance.subscriptionTypes)
  }

  public getSubscription() {
    return this.http.get(urls.finance.subscription)
  }

  public selectSubscription(id: number): Observable<{ url: string }> {
    return this.http.post(urls.finance.buySubscription, { type: id })
  }

  public recharge(amount: number): Observable<{ url: string }> {
    return this.http.post(urls.finance.pay, { amount })
  }

  public trialActivate(subscriptionType: number, successUrl: string, failUrl: string) {
    return this.http.post(urls.finance.trialActivation, { subscriptionType, successUrl, failUrl })
  }

  public addPaymentMethod(successUrl: string, failUrl: string): Observable<IAddPaymentMethod> {
    return this.http.post(urls.finance.addCard, { successUrl, failUrl })
  }
}
